import axios from 'axios'
import * as types from '@/actions/types'
import constants from '@/constants'

export function getEcwidShop(details = true) {
  const params = {
    params: {
      details,
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_ECWID}/frontpage`, params)
        .then((response) => {
          dispatch({
            type: types.SHOP_INJECT_PRODUCT,
            items: response.data.result.data.items,
          })
          dispatch({
            type: types.SHOP_INJECT_CATEGORIES,
            categories: response.data.result.categoryDetails,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getEcwidCategories(details = true) {
  const params = {
    params: {
      details,
    },
  }
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_ECWID}/frontpage`, params)
        .then((response) => {
          dispatch({
            type: types.SHOP_INJECT_CATEGORIES,
            categories: response.data.result.categoryDetails,
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}

export function getEcwidProduct(id) {
  return (dispatch) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`${constants.urls.API_ECWID}/product/${id}`)
        .then((response) => {
          dispatch({
            type: types.SHOP_INJECT_PRODUCT,
            items: [response.data.result.data],
          })
          resolve(response)
        })
        .catch((response) => {
          reject(response)
        })
    })
  }
}
